package com.tedd.db

import app.cash.sqldelight.Query
import app.cash.sqldelight.TransacterImpl
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlCursor
import app.cash.sqldelight.db.SqlDriver
import kotlin.Any
import kotlin.Long
import kotlin.String

public class OrganizationQueries(
  driver: SqlDriver,
) : TransacterImpl(driver) {
  public fun <T : Any> selectAll(mapper: (
    id: String,
    name: String,
    description: String?,
    color: String,
    icon: String,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = Query(-1_586_328_936, arrayOf("organization"), driver, "Organization.sq",
      "selectAll",
      "SELECT organization.id, organization.name, organization.description, organization.color, organization.icon, organization.order_index, organization.created_at, organization.updated_at, organization.is_deleted, organization.deleted_at, organization.synced_at FROM organization WHERE is_deleted = 0 ORDER BY order_index, name") {
      cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2),
      cursor.getString(3)!!,
      cursor.getString(4)!!,
      cursor.getLong(5)!!,
      cursor.getLong(6)!!,
      cursor.getLong(7)!!,
      cursor.getLong(8)!!,
      cursor.getLong(9),
      cursor.getLong(10)
    )
  }

  public fun selectAll(): Query<Organization> = selectAll { id, name, description, color, icon,
      order_index, created_at, updated_at, is_deleted, deleted_at, synced_at ->
    Organization(
      id,
      name,
      description,
      color,
      icon,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectById(id: String, mapper: (
    id: String,
    name: String,
    description: String?,
    color: String,
    icon: String,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = SelectByIdQuery(id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2),
      cursor.getString(3)!!,
      cursor.getString(4)!!,
      cursor.getLong(5)!!,
      cursor.getLong(6)!!,
      cursor.getLong(7)!!,
      cursor.getLong(8)!!,
      cursor.getLong(9),
      cursor.getLong(10)
    )
  }

  public fun selectById(id: String): Query<Organization> = selectById(id) { id_, name, description,
      color, icon, order_index, created_at, updated_at, is_deleted, deleted_at, synced_at ->
    Organization(
      id_,
      name,
      description,
      color,
      icon,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectDirty(mapper: (
    id: String,
    name: String,
    description: String?,
    color: String,
    icon: String,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = Query(253_973_257, arrayOf("organization"), driver, "Organization.sq",
      "selectDirty",
      "SELECT organization.id, organization.name, organization.description, organization.color, organization.icon, organization.order_index, organization.created_at, organization.updated_at, organization.is_deleted, organization.deleted_at, organization.synced_at FROM organization WHERE synced_at IS NULL OR synced_at < updated_at") {
      cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2),
      cursor.getString(3)!!,
      cursor.getString(4)!!,
      cursor.getLong(5)!!,
      cursor.getLong(6)!!,
      cursor.getLong(7)!!,
      cursor.getLong(8)!!,
      cursor.getLong(9),
      cursor.getLong(10)
    )
  }

  public fun selectDirty(): Query<Organization> = selectDirty { id, name, description, color, icon,
      order_index, created_at, updated_at, is_deleted, deleted_at, synced_at ->
    Organization(
      id,
      name,
      description,
      color,
      icon,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectByIdAnyState(id: String, mapper: (
    id: String,
    name: String,
    description: String?,
    color: String,
    icon: String,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = SelectByIdAnyStateQuery(id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2),
      cursor.getString(3)!!,
      cursor.getString(4)!!,
      cursor.getLong(5)!!,
      cursor.getLong(6)!!,
      cursor.getLong(7)!!,
      cursor.getLong(8)!!,
      cursor.getLong(9),
      cursor.getLong(10)
    )
  }

  public fun selectByIdAnyState(id: String): Query<Organization> = selectByIdAnyState(id) { id_,
      name, description, color, icon, order_index, created_at, updated_at, is_deleted, deleted_at,
      synced_at ->
    Organization(
      id_,
      name,
      description,
      color,
      icon,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun insert(
    id: String,
    name: String,
    description: String?,
    color: String,
    icon: String,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
  ) {
    driver.execute(630_158_342, """
        |INSERT INTO organization(id, name, description, color, icon, order_index, created_at, updated_at)
        |VALUES (?, ?, ?, ?, ?, ?, ?, ?)
        """.trimMargin(), 8) {
          bindString(0, id)
          bindString(1, name)
          bindString(2, description)
          bindString(3, color)
          bindString(4, icon)
          bindLong(5, order_index)
          bindLong(6, created_at)
          bindLong(7, updated_at)
        }
    notifyQueries(630_158_342) { emit ->
      emit("organization")
    }
  }

  public fun update(
    name: String,
    description: String?,
    color: String,
    icon: String,
    order_index: Long,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(975_104_534, """
        |UPDATE organization
        |SET name = ?, description = ?, color = ?, icon = ?, order_index = ?, updated_at = ?
        |WHERE id = ?
        """.trimMargin(), 7) {
          bindString(0, name)
          bindString(1, description)
          bindString(2, color)
          bindString(3, icon)
          bindLong(4, order_index)
          bindLong(5, updated_at)
          bindString(6, id)
        }
    notifyQueries(975_104_534) { emit ->
      emit("organization")
    }
  }

  public fun softDelete(
    deleted_at: Long?,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(-870_620_862,
        """UPDATE organization SET is_deleted = 1, deleted_at = ?, updated_at = ? WHERE id = ?""",
        3) {
          bindLong(0, deleted_at)
          bindLong(1, updated_at)
          bindString(2, id)
        }
    notifyQueries(-870_620_862) { emit ->
      emit("organization")
    }
  }

  public fun restore(updated_at: Long, id: String) {
    driver.execute(1_495_419_617,
        """UPDATE organization SET is_deleted = 0, deleted_at = NULL, updated_at = ? WHERE id = ?""",
        2) {
          bindLong(0, updated_at)
          bindString(1, id)
        }
    notifyQueries(1_495_419_617) { emit ->
      emit("organization")
    }
  }

  public fun hardDelete(id: String) {
    driver.execute(-1_050_683_069, """DELETE FROM organization WHERE id = ?""", 1) {
          bindString(0, id)
        }
    notifyQueries(-1_050_683_069) { emit ->
      emit("organization")
      emit("project")
    }
  }

  public fun markSynced(
    synced_at: Long?,
    id: String,
    updated_at: Long,
  ) {
    driver.execute(332_272_756,
        """UPDATE organization SET synced_at = ? WHERE id = ? AND updated_at <= ?""", 3) {
          bindLong(0, synced_at)
          bindString(1, id)
          bindLong(2, updated_at)
        }
    notifyQueries(332_272_756) { emit ->
      emit("organization")
    }
  }

  private inner class SelectByIdQuery<out T : Any>(
    public val id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("organization", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("organization", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(-1_931_515_461,
        """SELECT organization.id, organization.name, organization.description, organization.color, organization.icon, organization.order_index, organization.created_at, organization.updated_at, organization.is_deleted, organization.deleted_at, organization.synced_at FROM organization WHERE id = ? AND is_deleted = 0""",
        mapper, 1) {
      bindString(0, id)
    }

    override fun toString(): String = "Organization.sq:selectById"
  }

  private inner class SelectByIdAnyStateQuery<out T : Any>(
    public val id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("organization", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("organization", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(-1_950_379_808,
        """SELECT organization.id, organization.name, organization.description, organization.color, organization.icon, organization.order_index, organization.created_at, organization.updated_at, organization.is_deleted, organization.deleted_at, organization.synced_at FROM organization WHERE id = ?""",
        mapper, 1) {
      bindString(0, id)
    }

    override fun toString(): String = "Organization.sq:selectByIdAnyState"
  }
}
